import statusIconMap from '@/schema/statusIconMap.jsx';
import IconV2 from '../v2/IconV2.jsx';
import Button from '../Button.jsx';

const PanelAlert = ({ title, description, children, variant = 'info', iconClassName = '', preWrap = false, action, additionalAction, actionSize = 'xs', onClick, icon = null, iconProps = {}, style = {}, className = '' }) => {
  const Icon = icon ?? statusIconMap(variant);
  const descriptionLines = description
    ?.split(/\n/)
    ?.map((n) => n?.trim())
    ?.filter((n) => !!n);

  const hasActions = action || additionalAction;

  return (
    <div className={`comp-panel-alert ${variant} ${preWrap ? 'pre-wrap' : ''} ${className}`} style={style} onClick={onClick}>
      <IconV2 icon={Icon} className={iconClassName} {...iconProps} />
      <div className="alert-content">
        {title && <div className="alert-title">{title}</div>}
        {description && (
          <div className={`alert-description ${descriptionLines?.length > 1 ? 'multi-line' : ''}`}>
            {descriptionLines?.map((line, idx) => (
              <span className={''} key={idx}>
                {line}
              </span>
            ))}
          </div>
        )}
        {children && <div className="alert-description">{children}</div>}
      </div>
      {hasActions && (
        <div className="alert-actions">
          {additionalAction && (
            <Button className={additionalAction?.className || 'text'} size={actionSize} onClick={additionalAction.onClick} icon={additionalAction?.icon} iconProps={additionalAction?.iconProps} title={additionalAction?.title} {...(additionalAction.props || {})}>
              {additionalAction?.label}
            </Button>
          )}
          {action && (
            <Button className={action?.className || 'text negative-right'} size={actionSize} onClick={action.onClick} icon={action?.icon} iconProps={action?.iconProps} title={action?.title} {...(action.props || {})}>
              {action?.label}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default PanelAlert;
